import axios, { type AxiosResponse } from 'axios'
import { useInfiniteQuery, useQuery } from 'react-query'

import { baseUrl } from 'configs/api'
import { api, handleCommonErrors } from 'utils/api'

import type { IInfoTerkini } from 'types/info-terkini'

interface ResponseSuccessInfoTerkini {
  data: IInfoTerkini[]
  meta: any
}

export function useAPIInfoTerkiniList(categoryIds: string[]) {
  const categoryids = categoryIds.join(',')

  const queryId = categoryIds.length > 0 ? categoryids : 'all'
  return useInfiniteQuery(
    queryId,
    async ({ pageParam = 0 }): Promise<ResponseSuccessInfoTerkini> => {
      try {
        const response = await api<ResponseSuccessInfoTerkini>(
          '/aum/announcement/v2/announcements',
          {
            params: {
              limit: 10,
              offset: pageParam,
              categoryids,
            },
          }
        )
        return response
      } catch (error) {
        // Not found result return 404
        if (error.response.status === 404) {
          return {
            data: [],
            meta: {
              limit: 0,
              offset: 0,
              total: 0,
            },
          }
        } else {
          throw error
        }
      }
    },
    {
      getNextPageParam(_, pages) {
        const { offset, limit, total } = pages[pages.length - 1].meta
        const nextOffset = offset + limit
        if (nextOffset < total) return nextOffset
      },
    }
  )
}

interface IUseAPIGetInfoTerkiniWithParams {
  offset?: number
  limit: number
}
export function useAPIGetInfoTerkiniByParams(
  enabled: boolean,
  params: IUseAPIGetInfoTerkiniWithParams = { offset: 0, limit: 3 }
) {
  const apiPath = '/aum/announcement/v2/announcements'

  return useQuery<ResponseSuccessInfoTerkini>(
    apiPath,
    async () => {
      let response: ResponseSuccessInfoTerkini
      try {
        response = (
          await axios.get<any, AxiosResponse<ResponseSuccessInfoTerkini>>(
            `${baseUrl}${apiPath}`,
            { params }
          )
        ).data
      } catch (error) {
        handleCommonErrors(error?.response?.status, apiPath, error.response)
      }
      return response
    },
    {
      enabled,
      useErrorBoundary: false,
      staleTime: 60 * 60 * 1000, // 1 hour
      cacheTime: 60 * 60 * 1000, // 1 hour
    }
  )
}
